export const SET_VIEW = 'SET_VIEW';

export const setView = (view) => ({
    type: SET_VIEW,
    payload: view
});